module.exports = __webpack_public_path__ + "img/flower.80606c08.png";